import React, { useContext, useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { GrMail } from "react-icons/gr";
import { MdCall } from "react-icons/md";
import {
  AiOutlineShoppingCart,
  AiOutlineUser,
} from "react-icons/ai";
import axios from "axios";
import { SERVER_PATH } from "../../config/env";
import "../../assets/css/templatemo.css";
import Logo from "../../assets/img/logo.png";
import instaLogo from "../../assets/img/instagram.png";
import NavData from "../NavBar/navData";
import { UserContext } from "./../../context/userContext";

export default function AppHeader() {
  const { userData } = useContext(UserContext);
  const [navMap, setNavMap] = useState({});
  const [pathMap, setPathMap] = useState({});
  const [navItems, setNavItems] = useState([]);

  useEffect(() => {
    axios
      .get(`${SERVER_PATH}get/navbar.php?t=${Date.now()}`)
      .then((res) => {
        if (res.data && res.data.status === "success") {
          if (res.data.key_map) setNavMap(res.data.key_map);
          if (res.data.path_map) setPathMap(res.data.path_map);
          if (res.data.navbar) setNavItems(res.data.navbar);
        }
      })
      .catch((err) => {
        console.log("Error fetching navbar titles:", err);
      });
  }, []);

  return (
    <>
      <Nav
        className="navbar navbar-expand-lg bg-dark navbar-light d-none d-lg-block"
        id="templatemo_nav_top"
      >
        <div className="container-fluid text-light">
          <div className="w-100 d-flex justify-content-between">
            <div>
              <GrMail className="me-2 mb-1" />
              <a
                className="navbar-sm-brand text-light text-decoration-none me-2"
                href="mailto:farmsivam@gmail.com"
              >
                farmsivam@gmail.com
              </a>
              <MdCall className="me-2 mb-1" />
              <a
                className="navbar-sm-brand text-light text-decoration-none"
                href="tel:9840283274"
              >
                9840283274
              </a>
            </div>
            <div>
              <a
                href="https://instagram.com/sivamfarms.organics?igshid=MzRlODBiNWFlZA=="
                target="blank"
                className="text-light text-decoration-none"
              >
                <img
                  src={instaLogo}
                  height="13px"
                  width="auto"
                  className="me-1"
                  alt="sivamfarms instagram"
                />
                sivamfarms.organics
              </a>
            </div>
          </div>
        </div>
      </Nav>
      <Nav
        className="navbar navbar-expand-lg navbar-light shadow d-none d-lg-block"
        style={{
          backgroundColor: "var(--navbar)",
          position: "sticky",
          top: 0,
          zIndex: 3,
        }}
      >
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <Link
            className="logo align-self-center text-decoration-none"
            to="/"
            style={{ width: "auto" }}
          >
            <div
              style={{
                backgroundColor: "#FFFFFF",
                padding: "8px 24px",
                borderRadius: "10px",
                display: "inline-block",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
            >
              <img src={Logo} alt="sivam farms logo" height="auto" style={{ maxWidth: "260px", maxHeight: "70px", width: "100%", objectFit: "contain", display: "block" }} />
            </div>
          </Link>

          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#templatemo_main_nav"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="align-self-center collapse navbar-collapse flex-fill  d-lg-flex justify-content-lg-between"
            id="templatemo_main_nav"
          >
            <div className="flex-fill">
              <ul className="nav navbar-nav d-flex justify-content-between mx-lg-auto">
                <li className="nav-item">
                  <Link className="nav-link" to={pathMap.home || "/"} style={{color:"white"}}>
                    {navMap.home || "Home"}
                  </Link>
                </li>
                <NavData customTitles={navMap} customPaths={pathMap} />
                <li className="nav-item">
                  <Link className="nav-link" to={pathMap.about || "/about"} style={{color:"white"}}>
                    {navMap.about || "About"}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={pathMap.gallery || "/gallery"} style={{color:"white"}}>
                    {navMap.gallery || "Gallery"}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={pathMap.tracker || "/tracker"} style={{color:"white"}}>
                    {navMap.tracker || "Tracker"}
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={pathMap.unique || "/uniqueProducts"} style={{color:"white"}}>
                    {navMap.unique || "Unique Products"}
                  </Link>
                </li>
                {navItems && navItems.length > 0 && navItems.map((extraItem) => {
                  if (extraItem.status === 0) return null;
                  if (['home', 'herbal', 'wellness', 'about', 'gallery', 'tracker', 'unique', 'yoga_page', 'garden_page', 'food_page', 'policy', 'terms'].includes(extraItem.item_key)) return null;
                  return (
                    <li className="nav-item" key={extraItem.id || extraItem.item_key}>
                      <Link className="nav-link" to={extraItem.path || "/"} style={{color:"white"}}>
                        {extraItem.title}
                      </Link>
                    </li>
                  );
                })}
                <li className="nav-item">
                  <Link
                  style={{color:"white"}}
                    to="/cart"
                    className="nav-icon position-relative text-decoration-none"
                  >
                    <AiOutlineShoppingCart style={{ fontSize: "1.7em" }} />
                    <label className="position-absolute top-0 left-100 translate-middle badge rounded-pill bg-success text-light">
                      {userData?.cart?.length || 0}
                    </label>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                  style={{color:"white"}}
                    to="/profile"
                    className="nav-icon position-relative text-decoration-none"
                  >
                    <AiOutlineUser style={{ fontSize: "1.7em" }} />
                  </Link>
                </li>
              </ul>
            </div>
            {/* <div className="navbar align-self-center d-flex">
              <div className="d-lg-block flex-sm-fill mt-3 mb-4 col-7 col-sm-auto pr-3">
                <Link
                  className="nav-icon d-none d-lg-inline"
                  href="#one"
                  data-bs-toggle="modal"
                  data-bs-target="#templatemo_search_lg">
                  <AiOutlineSearch style={{ fontSize: "1.7em" }} />
                </Link>
              </div>
            </div> */}
          </div>
        </div>
      </Nav>
      {/* <div
        className="modal fade bg-white"
        id="templatemo_search_lg"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
          <div className="w-100 pt-1 mb-5 text-right">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <form
            action=""
            method="get"
            className="modal-content modal-body border-0 p-0">
            <div className="input-group mb-2">
              <input
                type="text"
                className="form-control"
                id="inputModalSearch"
                name="q"
                placeholder="Search ..."
              />
              <button
                type="submit"
                className="input-group-text bg-success text-light">
                <AiOutlineSearch />
              </button>
            </div>
          </form>
        </div>
      </div> */}
    </>
  );
}
